import { zonedTimeToUtc } from "date-fns-tz";
import format from "date-fns/format";

export const transformToAccurateDate = (dateString: string) => {
  const localDate = new Date(dateString);
  const utcDate = zonedTimeToUtc(localDate, "UTC");
  return format(utcDate, "h:mmaaa dd MMMM yyyy");
};
